export default function ChevronIcon(props) {
    return <svg className={props.className ? props.className : ""} xmlns="http://www.w3.org/2000/svg" width="13.28" height="8.055" viewBox="0 0 13.28 8.055">
    <path id="Pfad_12" data-name="Pfad 12" d="M7034,7244l5.933,5.934,5.933-5.934" transform="translate(-7033.293 -7243.293)" fill="none" stroke="#000" stroke-width="2"/>
  </svg>;
}